import React from 'react';

import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { atoms, colors, HStack, Primitive, text } from '@rtkwlf/fenrir-react';
import { faExternalLinkAlt } from '@rtkwlf/pro-solid-svg-icons/faExternalLinkAlt';
import { NavLink } from 'react-router-dom';

import type { SubMenuItem } from '@packages/components/navigation/navigation.constants';
import { DEFAULT_TAB_INDEX, INACTIVE_TAB_INDEX } from 'ae-constants/constants';

interface LeftMenuItemProps {
  item: SubMenuItem;
  index: number;
  onFocus: React.FocusEventHandler<HTMLAnchorElement>;
}

export const LeftMenuItem: React.FC<LeftMenuItemProps> = ({
  item,
  index,
  onFocus,
}) => {
  const isExternalLink = item.target === '_blank';

  return (
    <Primitive.li
      key={item.text}
      css={css({ boxSizing: 'initial', listStyle: 'none' })}
    >
      <HStack asChild marginLeft="xsmall" marginRight="xsmall">
        <NavLink
          to={item.to}
          className={atoms({
            textDecoration: 'none',
          })}
          css={css({
            '&:focus': {
              zIndex: 1,
            },
          })}
          end={item.end}
          target={item.target}
          tabIndex={index === 0 ? DEFAULT_TAB_INDEX : INACTIVE_TAB_INDEX}
          data-index={index}
          onFocus={onFocus}
        >
          {({ isActive }) => {
            return (
              <Primitive.span
                display="inline-flex"
                justifyContent="space-between"
                alignItems="center"
                flex={1}
                height="1.5rem"
                padding="smedium"
                paddingLeft="medium"
                borderRadius="default"
                textColor={{
                  default: isActive ? 'brandDefault' : 'body',
                  hover: 'brandDefault',
                }}
                backgroundColor={isActive ? 'infoHighlight' : 'widgetDefault'}
                fontWeight={isActive ? 'bold' : 'normal'}
                css={css({
                  '&:hover': {
                    backgroundColor: `rgb(${colors.background.info.highlight})`,
                    fontWeight: `${text.font.weight.bold}`,
                  },
                })}
              >
                {item.text}

                {isExternalLink && (
                  <FontAwesomeIcon
                    icon={faExternalLinkAlt}
                    color={`rgb(${colors.icon.info.default})`}
                  />
                )}
              </Primitive.span>
            );
          }}
        </NavLink>
      </HStack>
    </Primitive.li>
  );
};
